import React from 'react';
import { Typography, Box } from '@material-ui/core';

const SuspendedNotification = ({ contactInfo }) => {
  return (
    <Box>
      <Typography variant="h5" style={{ color: '#fff', marginBottom: '12px', fontWeight: 'bold' }}>
        Suspended
      </Typography>
      <Typography variant="body1" style={{ color: '#fff' }}>
        To continue to update your iPQF, please contact the iPQF Coordinator: {contactInfo}
      </Typography>
    </Box>
  );
};

export default SuspendedNotification;
